import { LayoutHOC } from 'base/ui/layout/layout';
import { IPurchaseOrderServices } from 'services/Main/purchaseOrder_services';
import createReceiveSchedule2 from '.';

export const createReceiveSchedule2Page = (layoutHOC: LayoutHOC, services: IPurchaseOrderServices) => {
  return layoutHOC(createReceiveSchedule2(services));
};
